import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import DialogBackdrop from "../ModalDialogs/DialogBackdrop";

const PaperlessSettingDialog = ({
  state,
  setState,
  paperlessConfirmation,
  setPaperlessConfirmation,
}) => {
  return (
    <Transition appear show={state} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        open={state}
        onClose={() => setState(false)}
      >
        <DialogBackdrop />
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="inline-block w-full max-w-5xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h2"
                className="dialog_label2 font-body text-xl font-bold text-left"
              >
                E-delivery authorization
                <button
                  className="ui-default-dialog-close"
                  onClick={() => setState(false)}
                >
                  <svg
                    className="ui-icon h-3.5 w-3.5"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-close"></use>
                  </svg>
                </button>
              </Dialog.Title>

              <hr />

              <Dialog.Description className="mx-auto lg:w-4/5">
                <p>
                  This Agreement to Receive Written Communications
                  Electronically ("Agreement") is {`<Life Ins Co Name>`}'s
                  paperless terms and conditions which applies to all
                  transactions and interactions with {`<Life Ins Co Name>`} and
                  its subsidiaries and affiliates ("{`<Life Ins Co Name>`}").
                  This may include the purchase of an insurance product,
                  insurance service, roadside membership or any other offering
                  made by {`<Life Ins Co Name>`}. Written communications may
                  include any policy related documents, billing statements,
                  claims communications, correspondence, notices, and
                  disclosures. This includes cancellation, nonrenewal,
                  conditional renewal, renewal with altered terms and premium
                  increase notices where permitted by state law.
                </p>

                <br />

                <p>
                  Your consent to this Agreement means you will no longer
                  receive paper copies of any written communication, with a few
                  exceptions:
                </p>

                <br />

                <ul className="list-disc list-inside indent-8">
                  <li className="mt-2">
                    Communications where {`<Life Ins Co Name>`} is required law
                    to provide paper copies
                  </li>
                  <li className="mt-2">
                    At our discretion, when we feel it will provide a better
                    customer experience to provide paper copies
                  </li>
                </ul>

                <br />

                <p>
                  Further, not all communications are currently available to be
                  sent electronically. As those communications become available,
                  we will send them electronically in accordance with your
                  paperless settings.{" "}
                </p>
                <br />
                <p>
                  Please read this Agreement in its entirety. Your consent to
                  this Agreement means you have read, understood and accepted
                  its terms and conditions. Your consent will be applied to all
                  future transactions with {`<Life Ins Co Name>`}.
                </p>

                <br />
                <ul className="list-disc list-inside indent-8">
                  <li className="mt-2">
                    Agreement modification: 
                    {`<Life Ins Co Name>`} reserves the right to modify this
                    Agreement at any time. You will be provided notice of any
                    change to this Agreement either by email or through your{" "}
                    {`<Life Ins Co Name>`} account. Your continued participation
                    in the paperless program after we provide notice will
                    constitute your acceptance of those changes.
                  </li>
                  <li className="mt-2">
                    Electronic communication methods: {`<Life Ins Co Name>`}{" "}
                    will deliver written communications to you either at the
                    email address you have provided or by sending you an email
                    letting you know that a written communication is available
                    for review in the {`<Life Ins Co Name>`} Self Service Portal
                    which can be accessed by logging into {`<www.XXXXX.com>`}
                     with your username and password. You agree that you have
                    the authority to receive written communications
                    electronically on behalf of all insureds under your policy
                    (life insurance communications will only be provided to the
                    individual consenting to this Agreement). You further agree
                    to access your {`<Life Ins Co Name>`} Self Service Portal
                    account and login with your user id and password to access
                    your written communications. Should you have any problems
                    with your {`<Life Ins Co Name>`} account, please contact{" "}
                    {`<Toll Free Number>`}. It is your responsibility to
                    maintain an active {`<Life Ins Co Name>`} Self Service
                    Portal account by which to access your written
                    communications.
                  </li>
                  <li className="mt-2">
                    Paper copies: You can print any written communication from
                    your {`<Life Ins Co Name>`} account. You may also request a
                    paper copy of any written communication, at no charge, by
                    calling {`<Toll Free Number>`}.
                  </li>
                  <li className="mt-2">
                    Requirements: You will need to meet the following
                    requirements to access, view, save and print your written
                    communications. You agree that you meet the following
                    requirements.
                    <ul className="list-decimal list-inside indent-16">
                      <li className="mt-2">
                        An internet enabled device with access to the internet
                        capable of sending/receiving email;
                      </li>

                      <li className="mt-2">
                        Software that enables you to view files in the Portable
                        Document Format (PDF), such as the free Adobe Reader;
                      </li>

                      <li className="mt-2">
                        A printer if you wish to print your documents;
                      </li>

                      <li className="mt-2">
                        A valid e-mail account with the ability to accept new
                        emails. You must ensure that your email server and
                        spam-blocking software do not block our emails. We are
                        not responsible for problems arising from emails sent to
                        an inactive email address if you failed to update your
                        email address in a timely manner.It is your
                        responsibility to provide {`<Life Ins Co Name>`} with a
                        valid email address and maintain a valid email address
                        on file with {`<Life Ins Co Name>`}. You must also keep
                        your email address active and capable of receiving new
                        emails. You must immediately inform{" "}
                        {`<Life Ins Co Name>`} of any changes to your email
                        address. You can update your email address in the{" "}
                        {`<Life Ins Co Name>`} Self Service Portal by accessing 
                        {`<www.xxxx.com>`} using your username and password or
                        by calling {`<toll free number >`}.{" "}
                      </li>
                    </ul>
                  </li>

                  <li className="mt-2">
                    Paperless settings: Once you agree to receive written
                    communications from {`<Life Ins Co Name>`} electronically,
                    you can manage your paperless preferences by logging into
                    your {`<Life Ins Co Name>`} account at 
                    {`<www.XXXXX.com>`}
                  </li>

                  <li className="mt-2">
                    Consent withdrawal: Your consent to this Agreement will
                    remain valid and in effect until you withdraw it. You may
                    withdraw your consent to this Agreement by calling 1-800-
                    {`<LIFE INS CO NAME>`}. Your withdrawal will apply to all
                    policies and services with {`<Life Ins Co Name>`}. If an
                    email address you provide later becomes invalid,{" "}
                    {`<Life Ins Co Name>`} may treat that as a withdrawal of
                    consent. Any withdrawal will result in the removal of any
                    current or future paperless discount. Further, if you
                    purchased a product or service which mandates or otherwise
                    requires the use of electronic delivery, your withdrawal
                    could result in the termination of that product or service.
                    A withdrawal of your consent to this Agreement will be
                    effective only after we have had reasonable time to process
                    your request.
                  </li>

                  <li className="mt-2">
                    Other {`<Life Ins Co Name>`} paperless agreements: If you
                    previously purchased or in the future purchase a product or
                    service from {`<Life Ins Co Name>`} which requires you to
                    enter into a separate agreement for the electronic delivery
                    of written communications, the terms of that separate
                    agreement will control. This Agreement will not alter the
                    terms and conditions of that separate agreement.
                  </li>

                  <li className="mt-2">
                    For California policyholders: The option to transact
                    business electronically with {`<Life Ins Co Name>`} and its
                    affiliate companies is voluntary. Records which may be
                    delivered to you electronically upon your consent to
                    electronic delivery include all documents, notices and
                    correspondence related to your insurance policy, premium
                    payments (billing) and claims. You can unenroll your
                    policies from electronic delivery, or update your email
                    address on file, by changing your paperless settings/contact
                    information in your {`<Life Ins Co Name>`} account
                    accessible via or {`<www.xxxx.com>`} by calling{" "}
                    {`<Toll Free Number>`}.
                  </li>
                </ul>
                <br />
                <p>
                  By providing my consent I acknowledge that I have read this
                  Agreement and agree to receive written communications from{" "}
                  {`<Life Ins Co Name>`} electronically according to the terms
                  and conditions described above. If you do not agree to all the
                  terms and conditions contained within this Agreement, do not
                  consent (see Consent Withdrawal above).
                </p>
              </Dialog.Description>

              <div className="block text-right mt-6">
                <button
                  className="ui-btn-secondary min-w-[140px] mt-4"
                  aria-label="Go to my policies now"
                  onClick={() => {
                    setPaperlessConfirmation(false);
                    setState(false);
                  }}
                >
                  Canel
                </button>
                <button
                  className="ui-btn-primary min-w-[140px] mt-4"
                  aria-label="Go to my policies now"
                  onClick={() => {
                    setPaperlessConfirmation(true);
                    setState(false);
                  }}
                >
                  Accept
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PaperlessSettingDialog;
